module.exports = __webpack_public_path__ + "static/womens-tech-network-logo-square-fd9676bf5bb34b2d8f33bacbbab37a1e.png";